import { render, staticRenderFns } from "./unbindDetailCollapse.vue?vue&type=template&id=c48d77b0&scoped=true&"
import script from "./unbindDetailCollapse.vue?vue&type=script&lang=js&"
export * from "./unbindDetailCollapse.vue?vue&type=script&lang=js&"
import style0 from "./unbindDetailCollapse.vue?vue&type=style&index=0&id=c48d77b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48d77b0",
  null
  
)

export default component.exports